import { render, staticRenderFns } from "./DepositsTable.vue?vue&type=template&id=170a5f28&scoped=true&"
import script from "./DepositsTable.vue?vue&type=script&lang=js&"
export * from "./DepositsTable.vue?vue&type=script&lang=js&"
import style0 from "./DepositsTable.vue?vue&type=style&index=0&id=170a5f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170a5f28",
  null
  
)

export default component.exports